import {
    protectedApiCall,
    persUrl,
    sentryAPIErrorV2,
    handleTryPremiumContentClick,
} from './module_common';

import {Howl} from 'howler';

import Cookies from 'js-cookie'

const playerBtnBookClass = 'player-btn-book-attach-clk';
const playerBtnArticleClass = 'player-btn-article-attach-clk';
const playerBtnTheupdateClass = 'player-btn-tu-attach-clk';

const state = [];

state.playing = false;
state.seconds = 0;
state.loading = false;

const PlayerCard = function (playlist) {
    this.playlist = playlist;
    this.index = 0;
};

const doRemoteBookUpdateProgressCard = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"book_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteBookUpdateProgressCard",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('Error sending listen progress for book, from card')
            error.name = 'doRemoteBookUpdateProgressCard fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

const doRemoteArticleUpdateProgressCard = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"article_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteArticleUpdateProgressCard",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('Error sending listen progress for article, from card')
            error.name = 'doRemoteArticleUpdateProgressCard fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

const doRemoteTheUpdateUpdateProgressCard = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"theupdate_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteTheUpdateUpdateProgressCard",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
            }
            const error = new Error('Error sending listen progress for theupdate, from card')
            error.name = 'doRemoteTheUpdateUpdateProgressCard fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

const doRemoteUpdateProgressCard = function (seek, data) {
    seek = parseInt(seek);
    if (!seek) return;

    if (state.playing) {
        switch (data.contType) {
            case 'book':
                doRemoteBookUpdateProgressCard(data.ep, data.id, seek)
                break;
            case 'article':
                doRemoteArticleUpdateProgressCard(data.ep, data.id, seek)
                break;
            case 'theupdate':
                doRemoteTheUpdateUpdateProgressCard(data.ep, data.id, seek)
                break;
            default:
                break;
        }
    }
};

// AUDIO_PLAYER_CARD_IS_LOADING is used in a strange way
// ex.: in onpause is set to true
let AUDIO_PLAYER_CARD_IS_LOADING = true;

let AUDIO_CONSOLE_CARD_PAUSE_LOAD = "";
let AUDIO_CONSOLE_CARD_PLAY_LOAD = "";
let AUDIO_CONSOLE_CARD_ICONS_CLASSES = "";

const doUpdatePlayButtonCard = function(loading, target) {
    if (loading === AUDIO_PLAYER_CARD_IS_LOADING) return;
    AUDIO_PLAYER_CARD_IS_LOADING = loading;
    
    if (loading) {
        target.removeClass(AUDIO_CONSOLE_CARD_ICONS_CLASSES).addClass(UIconfig.loadingClass)
    } else {
        target.removeClass(AUDIO_CONSOLE_CARD_ICONS_CLASSES).addClass(UIconfig.playClass)
    }
};

PlayerCard.prototype = {
    play: function (index) {
        const self = this;

        if (state["loading"]) return

        let data = self.playlist[index];

        AUDIO_PLAYER_CARD_IS_LOADING = false;
        doUpdatePlayButtonCard(true, data.target);

        self.initSound(index);

        let sound = data.howl;
        sound.play();
        self.index = index;
    },
    pause: function () {
        const self = this;

        // Get the Howl we want to manipulate.
        const sound = self.playlist[self.index].howl;

        // Pause the sound.
        sound.pause();
    },
    volume: function (val) {
        let self = this;

        // Update the global volume (affecting all Howls).
        Howler.volume(val);
    },
    step: function () {
        const self = this;
        const data = self.playlist[self.index]
        
        // Get the Howl we want to manipulate.
        const sound = data.howl;

        // Determine our current seek position.
        let seek = sound.seek() || 0;

        // If the sound is still playing, continue stepping.
        if (sound.playing()) {
            requestAnimationFrame(self.step.bind(self));
            doUpdatePlayButtonCard(false, data.target);
        } else {
            doUpdatePlayButtonCard(true, data.target);
            setTimeout(function () {
                self.step();
            }, 5);
        }
        progressNotifyCard(seek, data);
    },
    initSound: function (index) {        
        const self = this;
        let data = self.playlist[index];
        
        if (data.howl) return

        let startFrom = data.current

        data.howl = new Howl({
            src: [data.file],
            //For Safari
            preload: true,
            html5: true,
            onpause: function () {
                state.playing = false;
                AUDIO_PLAYER_CARD_IS_LOADING = true;
                doUpdatePlayButtonCard(true, data.target);
                data.target.removeClass(AUDIO_CONSOLE_CARD_PLAY_LOAD).addClass(UIconfig.pauseClass)
                data.target.parent().removeClass("content-playing")
            },
            onplay: function () {
                state.playing = true;
                data.target.removeClass(AUDIO_CONSOLE_CARD_PAUSE_LOAD).addClass(UIconfig.playClass)
                data.target.parent().addClass("content-playing")
                requestAnimationFrame(self.step.bind(self));
            },
            onload: function () {
                const tot = data.howl.duration();

                if (startFrom > 0) {
                    data.howl.seek(startFrom);
                }
                
                // end of the book, set start to 0
                if (startFrom >= tot){
                    data.howl.seek(0);
                }
                data.loaded = true
            },
            onstop: function () {
                data.target.removeClass(AUDIO_CONSOLE_CARD_PLAY_LOAD).addClass(UIconfig.pauseClass)
                data.target.parent().removeClass("content-playing")
            },
            onend: function () {
                data.target.removeClass(AUDIO_CONSOLE_CARD_PLAY_LOAD).addClass(UIconfig.pauseClass)
                data.target.parent().removeClass("content-playing")
                doRemoteUpdateProgressCard(Math.round(data.howl.duration()), data);
                state.playing = false;
                // if we don't set to true, we get a spinner on play button
                AUDIO_PLAYER_CARD_IS_LOADING = true;
            },
        });
        data.howl.mobileAutoEnable = "true";

    },
    itemIsInPlaylist: function(playlistItem) {
        const self = this;
        const res = self.playlist.filter(i => i.id == playlistItem.id && i.contType == playlistItem.contType)
        return res.length == 1
    },
    isLoading: function() {
        const self = this;
        const res = self.playlist.filter(i => i.loaded == false)
        return res.length >= 1
    },
    addItemAndPlay: function(playListItem) {
        const self = this;
        if (self.isLoading()) return
        playListItem.loaded = false
        playListItem.lastApiCall = 0
        const idx = self.playlist.push(playListItem) - 1;
        playListItem.target.click(playerClosure(self, idx));
        
        handleButtonToggle(self, state, idx)
    },
    stopAll: function() {
        const self = this;
        self.playlist.forEach((i)=>{
            i.howl.pause();
        })
    },
    getPlaying: function() {
        const self = this;
        for (const i of self.playlist){
            if (i.howl.playing()) return i
        }
        return null
    }
};

const progressNotifyCard = function (seek, data) {
    if (!seek) return;
    
    const intSeek = parseFloat(seek).toFixed(0);
    if (!(intSeek % UIconfig.apiRateCall)) {
        if (intSeek !== data.lastApiCall) {
            data.lastApiCall = intSeek;
            doRemoteUpdateProgressCard(intSeek, data);
        }
    }
};

function handleButtonToggle (player, state, idx) {
    if (state.playing) {
        player.pause();
        if (idx !== player.index) player.play(idx);
    } else {
        player.play(idx);
    }
}

function playerClosure(player, idx) {
    return function(){
        if (player.isLoading()) return
        handleButtonToggle(player, state, idx)
    }
}

function handleCardPlayerSuccess(contType) {
    return function(data) {
        let current = data.reaction.progress.listen.current
        let audioUrl = ""
        let id = ""
        let ep = ""
        switch (contType) {
            case 'book':
                audioUrl = data.book.translation.audio.url
                id = data.book.id
                ep = bPLEP
                break;
            case 'article':
                audioUrl = data.article.translation.audio.url
                if (audioUrl === "") {
                    handleTryPremiumContentClick('#');
                    return
                }
                id = data.article.id
                ep = aPLEP
                break;
            case 'theupdate':
                audioUrl = data.theupdate.translation.sound_url
                id = data.theupdate.id
                ep = thPLEP
                break;
            default:
                break;
        }

        const playlistItem = {
            file: audioUrl, 
            id: id, 
            contType: contType, 
            current: current, 
            target: $(".cardPlayButton" + id), 
            ep: ep,
        }
        if (!player.itemIsInPlaylist(playlistItem)){
            player.addItemAndPlay(playlistItem)
        }
    }
}

function handleCardPlayerError(contType) {
    return function() {
        switch (contType) {
            case 'book':
                break;
            case 'article':
                return false;
            case 'theupdate':
                // actually click event is managed by parent click function
                return false
            default:
                return false;
        }
        handleTryPremiumContentClick('#');
        return false;    
    }
}

let player;

export const stopAllCard = function(){
    if (typeof player === 'undefined') return
    player.stopAll()
}

export const getItemPlaying = function(){
    if (typeof player === 'undefined') return null
    return player.getPlaying()
}

export const handleCardPlayer = function(contType, id) {
    if (typeof player === 'undefined'){
        player =  new PlayerCard([])
    }

    if (player.itemIsInPlaylist({id: id, contType: contType})) return false

    let bearer = Cookies.get('Authorization');
    if (typeof bearer === 'undefined') return false

    let base = "";
    let version = "";
    switch (contType) {
        case 'book':
            base = "/books/"
            break;
        case 'article':
            base = "/articles/"
            break;
        case 'theupdate':
            base = "/theupdates/"
            version = "v2"
            break;
        default:
            return false;
    }
    const url = base+id
    
    var success = handleCardPlayerSuccess(contType)
    var error = handleCardPlayerError(contType)
    protectedApiCall("GET", url, "", success, error, true, false, version);
    return false
}

const UIconfig = {};

export const configPlayerCard = function () {
    UIconfig.playClass = 'audio-play';
    UIconfig.pauseClass = 'audio-pause';
    UIconfig.loadingClass = 'audio-loading';
    UIconfig.playerWrapClass = 'player-wrap';
    AUDIO_CONSOLE_CARD_ICONS_CLASSES = UIconfig.pauseClass + " " + UIconfig.loadingClass + " " + UIconfig.playClass;
    AUDIO_CONSOLE_CARD_PAUSE_LOAD = UIconfig.pauseClass + " " + UIconfig.loadingClass;
    AUDIO_CONSOLE_CARD_PLAY_LOAD = UIconfig.playClass + " " + UIconfig.loadingClass;

    UIconfig.apiRateCall = 10;
    UIconfig.volume = 0.5;
};

function manageCardPlayerBtn(e){
    e.preventDefault();
    e.stopPropagation()
    const currentTarget = e.currentTarget
    const elId = $(currentTarget).data('cardid')
    handleCardPlayer(currentTarget.contentType, elId)
}

export const attachBookCardPlayerBtn = function(){
    const els = document.getElementsByClassName(playerBtnBookClass)
    for (const el of els) {
        el.addEventListener("click", manageCardPlayerBtn);
        el.contentType = 'book'
    }
}

export const attachArticleCardPlayerBtn = function(){
    const els = document.getElementsByClassName(playerBtnArticleClass)
    for (const el of els) {
        el.addEventListener("click", manageCardPlayerBtn);
        el.contentType = 'article'
    }
}

export const attachTheUpdateCardPlayerBtn = function(){
    const els = document.getElementsByClassName(playerBtnTheupdateClass)
    for (const el of els) {
        el.addEventListener("click", manageCardPlayerBtn);
        el.contentType = 'theupdate'
    }
}